import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../pages/UserContext";
import isTokenValid from "../utlities/auth.utility";
import { HOME_URL } from "../utlities/core.constants";

export default function useAuthGuard() {
  const {token} = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if(!isTokenValid(token)){
      navigate(HOME_URL)
    }
  }, [token])
}
